import React, { useEffect, useRef, useState } from "react";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Input, Select, Tag, message } from "antd";
import NutritionDrawer, { DrawerFooter } from "@components/nutrition/nutrition-drawer";
import { registerSprCards } from "./spr-cards-api";
import { cardShortCode } from "@core/card-keys";
import "./spr-cards.css";

const SprCardsRegisterDrawer = ({ vids, open, onClose, onSaved }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const inputRef = useRef(null);
  const [vid, setVid] = useState();
  const [key, setKey] = useState("");
  const [keys, setKeys] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setVid(vids?.[0]?.vid);
      setKey("");
      setKeys([]);
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  }, [open, vids]);

  const addKey = () => {
    const clean = key.trim().toUpperCase();
    if (!clean) return;
    if (!cardShortCode(clean)) {
      messageApi.warning("У кода нет короткого номера — будет добавлен как есть");
    }
    setKeys((old) => (old.includes(clean) ? old : [...old, clean]));
    setKey("");
    inputRef.current?.focus();
  };

  const register = async () => {
    if (!vid) {
      messageApi.warning("Выберите тип карты");
      return;
    }
    setSaving(true);
    try {
      const result = await registerSprCards({ vid, keys });
      const created = result?.created?.length || 0;
      const skipped = result?.skipped?.length || 0;
      messageApi.success(`Создано ${created}${skipped ? `, пропущено ${skipped} (уже есть)` : ""}`);
      onSaved?.();
      onClose();
    } catch (e) {
      messageApi.error(e?.message || "Не удалось зарегистрировать карты");
    } finally {
      setSaving(false);
    }
  };

  return (
    <NutritionDrawer open={open} title="Регистрация карт" width={440} onClose={onClose}>
      {contextHolder}
      <div className="spr-cards-register">
        <Select
          value={vid}
          options={(vids || []).map((x) => ({ value: x.vid, label: x.name }))}
          onChange={setVid}
          style={{ width: "100%" }}
          placeholder="Тип карты"
        />
        <Input
          ref={inputRef}
          value={key}
          size="large"
          autoComplete="off"
          placeholder="Поднесите карту к считывателю или введите код"
          onChange={(e) => setKey(e.target.value)}
          onPressEnter={addKey}
        />
        <div className="spr-cards-register-list">
          {keys.map((k) => (
            <div key={k} className="spr-cards-register-row">
              <span className="spr-cards-register-key">{k}</span>
              {cardShortCode(k)
                ? <Tag>{cardShortCode(k)}</Tag>
                : <Tag color="orange">нет короткого кода</Tag>}
              <Button
                type="text"
                size="small"
                danger
                icon={<DeleteOutlined />}
                onClick={() => setKeys((old) => old.filter((x) => x !== k))}
              />
            </div>
          ))}
          {!keys.length && <div className="nutrition-empty">Коды ещё не добавлены</div>}
        </div>
      </div>
      <DrawerFooter
        onSave={keys.length ? register : null}
        onClose={onClose}
        saving={saving}
        saveText={`Зарегистрировать (${keys.length})`}
      />
    </NutritionDrawer>
  );
};

export default SprCardsRegisterDrawer;
